import Change from '@/components/ui/Change'
import { formatMetric, isMoveMetric } from '@/features/screener/lib/format'
import type { Money } from '@/lib/money'
import type { Metric } from '@/schemas/screener'

/**
 * One metric's figure, wherever the screen prints one: a move signed and in the market colours
 * (`Change`), any other figure in its unit's own words, and a figure mm-be did not compute as the
 * app's dash.
 */
export default function MetricFigure({ metric, value }: { metric: Metric; value: Money | null }) {
  if (value === null) return <span className="text-muted-foreground">—</span>
  if (isMoveMetric(metric)) return <Change value={value} percent />
  return <span className="tnum">{formatMetric(metric, value)}</span>
}
